import { Box, Card } from '@factorialco/deprecated-design-system'
import { AvailableModules } from 'generated/featureDefinitions'
import {
  EngagementSettingsRootPageDocument,
  PulseParticipationDocument,
} from 'generated/resources/graphql'

import { DateNavigator } from 'modules/core/components/DateNavigator'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import EmployeePulseDatatable from 'modules/engagement/components/EmployeePulseDatatable'
import { useWeekNavigation } from 'modules/engagement/hooks/useWeekNavigation'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import Activate from './Activate'
import Chart from './Chart'

const PulseParticipation = () => {
  const { company } = useCurrentSession()
  const { startDate, endDate, handleDateRangeChange } = useWeekNavigation()
  const { data, loading } = useQuery(EngagementSettingsRootPageDocument, {
    variables: { companyIds: company.id, moduleAvailabilityIds: [AvailableModules.engagement] },
  })
  const { data: teamsData, loading: teamsLoading } = useQuery(PulseParticipationDocument)

  const advancedConfigurationEnabled =
    data?.features.featuresConnection.edges.at(0)?.node.enabled ?? false
  const settings = data?.engagement?.settings?.at(0)
  const employeePulseEnabled = settings?.employeePulseEnabled ?? false
  const settingsManage = teamsData?.engagement?._policies?.settingsManage?.can ?? false

  const settingsManageEnabled =
    settingsManage && !employeePulseEnabled && settings && advancedConfigurationEnabled

  return (
    <ResponsivePage.Body loading={loading || teamsLoading} error={null}>
      <Box gap={'s48'}>
        {settingsManageEnabled && <Activate />}
        <EmployeePulseDatatable
          dateRange={{ from: startDate, to: endDate }}
          teams={teamsData?.teams.teamsConnection.edges.map((edge) => edge.node) || []}
          tags={teamsData?.signals.tagsConnection.edges.map((edge) => edge.node) || []}
          actions={
            <DateNavigator
              startDate={startDate}
              endDate={endDate}
              onDateRangeChange={handleDateRangeChange}
              regularPeriods={['week']}
            />
          }
        >
          <Box width="full" height="s400">
            <Card>
              <Card.Title size="small">
                {i18n.t('engagement.pulse.dashboard.chart.title')}
              </Card.Title>

              <Card.Content>
                <Chart startDate={startDate} endDate={endDate} />
              </Card.Content>
            </Card>
          </Box>
        </EmployeePulseDatatable>
      </Box>
    </ResponsivePage.Body>
  )
}

export default PulseParticipation
